import React from 'react';
import { Button } from '@naf-simba/elements-buttons';

interface Props {
  expanded: boolean;
  onClick: () => void;
  moreText?: 'flere' | 'mer' | 'alle';
}

export const ShowMoreButton = ({ expanded, onClick, moreText = 'flere' }: Props) => (
  <Button variant="outlined" onClick={onClick}>
    {expanded ? 'Vis færre' : `Vis ${moreText}`}
  </Button>
);
